import { errorValidation, maskList, geoIpLookup } from './utils';

let profilePhone = $('#profile_phone');

/**
 * Init intlTelInput
 */
if (profilePhone.length) {
	$(window).on('load', function () {
		let phones_exist = false;
		[profilePhone].forEach(phoneInput => {
			var phoneValue = phoneInput.val();
			if (phoneValue) {
				phones_exist = true;
				setTimeout(function () {
					phoneInput.val(phoneValue);
				}, 500);
			}
		});

		if (!phones_exist) {
			setTimeout(function () {
				geoIpLookup(countryCode => {
					[profilePhone].forEach(phoneInput => {
						phoneInput.intlTelInput('setCountry', countryCode.toLowerCase());
						const maskObj = maskList.find(mask => {
							return (
								mask.cc &&
								typeof mask.cc === 'string' &&
								mask.cc.toLowerCase() === countryCode.toLowerCase()
							);
						});
						if (maskObj) {
							console.log(`Applying mask for ${maskObj.cc}: ${maskObj.mask}`);
							phoneInput.inputmask('remove');
							phoneInput.inputmask({ mask: maskObj.mask });
						}
					});
				});
			}, 500);
		}
	});

	[profilePhone].forEach(phoneInput => {
		phoneInput.intlTelInput({
			initialCountry: 'auto', // Automatically detect the country
			placeholderNumberType: 'aggressive',
			utilsScript:
				'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.14/js/utils.js',
			separateDialCode: false,
			allowDropdown: false,
		});

		phoneInput.inputmasks({
			inputmask: {
				definitions: {
					'#': {
						validator: '[0-9]',
						cardinality: 1,
					},
				},
				//clearIncomplete: false,
				showMaskOnHover: false, // Show mask
				autoUnmask: true, // Remove country code when input is empty
			},
			match: /[0-9]/,
			replace: '#',
			list: maskList,
			listKey: 'mask',
			onMaskChange: function (maskObj, completed) {
				if (maskObj) {
					console.log(`Applying mask for ${maskObj.cc}: ${maskObj.mask}`);
					let countryCode = Array.isArray(maskObj.cc)
						? maskObj.cc[0].toLowerCase()
						: maskObj.cc.toLowerCase();
					phoneInput.intlTelInput('setCountry', countryCode);
				} else {
					console.log(`No mask found, applying default mask`);
					phoneInput.inputmask({ mask: '9999999999' }); // Fallback mask
				}
			},
		});

		// On blur: validate phone number
		phoneInput.focusout(function () {
			if ($.trim(phoneInput.val())) {
				if (phoneInput.intlTelInput('isValidNumber')) {
					console.log('isValidNumber');
				} else {
					phoneInput.addClass('_error');
				}
			}
		});

		// On keydown: reset
		phoneInput.keydown(function () {
			phoneInput.removeClass('_error');
		});
	});
}
/**
 * Add custom validation method
 */
$.validator.addMethod(
	'validateProfilePhone',
	function (value, element) {
		return $(element).intlTelInput('isValidNumber');
	},
	window.translations.phoneInvalid
);

/**
 * Validate forms
 */
(() => {
	// Profile
	$("form[name='profile']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'profile[name]': {
				required: true,
			},
			'profile[surname]': {
				required: true,
			},
			'profile[email]': {
				required: true,
				email: true,
			},
			'profile[phone]': {
				required: true,
				validateProfilePhone: true,
			},
			'profile[mc]': {
				required: true,
			},
			'profile[dot]': {
				required: true,
			},
			'profile[carrier]': {
				required: true,
			},
			'profile[role]': {
				required: true,
			},
		},
		messages: {
			'profile[name]': {
				required: window.translations.required,
			},
			'profile[surname]': {
				required: window.translations.required,
			},
			'profile[email]': {
				required: window.translations.required,
				email: window.translations.emailInvalid,
			},
			'profile[phone]': {
				required: window.translations.required,
			},
			'profile[mc]': {
				required: window.translations.required,
			},
			'profile[dot]': {
				required: window.translations.required,
			},
			'profile[carrier]': {
				required: window.translations.required,
			},
			'profile[role]': {
				required: window.translations.required,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});

	// Profile reset
	$("form[name='profile_reset']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'profile_reset[current_password]': {
				required: true,
			},
			'profile_reset[password]': {
				required: true,
			},
			'profile_reset[confirm_password]': {
				required: true,
				equalTo: '#password',
			},
		},
		messages: {
			'profile_reset[current_password]': {
				required: window.translations.required,
			},
			'profile_reset[password]': {
				required: window.translations.required,
			},
			'profile_reset[confirm_password]': {
				required: window.translations.required,
				equalTo: window.translations.equalTo,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
})();
